import { useMemo } from 'react';

import { UserCommunication } from '@this+that/models';

import { ShortcutContext } from './types';
import { useEmailListNavigation } from './useEmailListNavigation';
import { wasRecentInputEnter } from './utils';

interface UseSearchNavigationProps {
  filteredCommunications: UserCommunication[];
  isLoading?: boolean;
}

export function useSearchNavigation({
  filteredCommunications,
  isLoading = false,
}: UseSearchNavigationProps) {
  const options = useMemo(
    () => ({ shouldBlockOpen: () => isLoading || wasRecentInputEnter() }),
    [isLoading],
  );

  return useEmailListNavigation({
    filteredCommunications,
    context: ShortcutContext.SEARCH,
    options,
  });
}
